import React, { useState, useEffect } from "react";
import { Input, Row, Button, Form, FormGroup, Label, Col, Container, Card, CardBody } from 'reactstrap';

import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useSelector } from "react-redux";
import { useCookies } from 'react-cookie';
import { useParams, useNavigate } from "react-router-dom"; // Importe o useNavigate


import {  
  ComboboxEmpresa, 
  ComboboxEmpresaParceira, 
  ComboboxGrupoDocumento,   
  
  ComboboxEmpresaPlanta,   
  ComboboxPlantaParceira,
  ComboboxDocumento, 
  ComboboxIntercambio
} from '../../../components/Common/Fields';

import EditaPermissao from "../../../components/Common/EditaPermissao";
import axios from 'axios';
import config from "../../../config";

const PermissaoEdit = () => {
  document.title = "Editar Permissões | Upzet - React Admin & Dashboard Template";

  const { id } = useParams(); // Pega o ID da permissão da URL
  
  const navigate = useNavigate(); // Adicione o hook useNavigate

  const { userControle } = useSelector((state) => ({
    userControle: state.login.user,
  }));

  // Estados para os campos
  const [selectedEmail, setSelectedEmail] = useState(); // Empresa Origem
  const [selectedUsuarioID, setSelectedUsuarioID ] = useState(); // Empresa Origem
  const [selectedNome, setSelectedNome] = useState(); // Empresa Origem

  const [selectedEmpresa, setSelectedEmpresa] = useState(); // Empresa Origem
  const [selectedGrupoDocumento, setSelectedGrupoDocumento] = useState(); // Grupo Documento
  const [selectedEmpresaParceira, setSelectedEmpresaParceira] = useState(); // Empresa Parceira

  const [selectedPlanta, setSelectedPlanta] = useState(null); // Planta Origem  
  const [selectedPlantaParceira, setSelectedPlantaParceira] = useState(null); // Planta Parceira  
  const [selectedDocumento, setSelectedDocumento] = useState(null); // Documento
  const [selectedIntercambio, setSelectedIntercambio] = useState(null);

  const [visivel, setVisivel] = useState(false); // Visível
  const [ativo, setAtivo] = useState(false); // Ativo

  const [cookies] = useCookies(['_csrf_token']);

  // Carregar os dados da permissão para edição
  useEffect(() => {
    const fetchPermissaoData = async () => {
      try {
        const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
          proc: 'FRONT_Permissao_Obter',
          requestData: { "ID_Permissao": id }
        }, {
          headers: {
            "X-CSRF-Token": cookies._csrf_token.csrfToken
          }
        });
        
        const data = response.data[0];
        console.log('Data da permissão:', data);
        
        if (data) {
          
          // Preenche os valores diretamente com os dados recebidos da API
          setSelectedEmail(data.Email);
          setSelectedUsuarioID(data.ID_Usuario);
          setSelectedNome(data.Nome_Completo);

          setSelectedEmpresa({
            value: data.ID_Empresa_Origem,
            label: data.Empresa, // Nome da empresa origem
          });
          
          setSelectedPlanta({
            value: data.ID_Planta_Origem,
            label: data.Planta, // Nome da planta origem
          });

          setSelectedEmpresaParceira({
            value: data.ID_Empresa_Destino,
            label: data.Empresa_Parceira, // Nome da empresa parceira
          });

          setSelectedPlantaParceira({
            value: data.ID_Planta_Destino,
            label: data.Planta_Parceira, // Nome da planta parceira
          });

          setSelectedGrupoDocumento({
            value: data.ID_Documento_Grupo,
            label: data.Grupo_Documentos, // Nome do grupo de documento

          });

          setSelectedDocumento({
            value: data.ID_Documento,
            label: data.Documento, // Nome do documento
          });

          setSelectedIntercambio({
            value: data.ID_Intercambio,
            label: data.Intercambio, // Nome do documento
          });


          setVisivel(data.Visivel === "S");
          setAtivo(data.Ativo === "S");

        } else {
        setSelectedEmpresa(null); // Caso não haja dados
        setSelectedEmpresaParceira(null); // Caso não haja dados
        setSelectedGrupoDocumento(null); // Caso não haja dados
        

        }

      } catch (error) {
        console.error("Erro ao carregar os dados da permissão:", error);
      }
    };

    fetchPermissaoData();
  }, [id, cookies._csrf_token.csrfToken]);

  // Empresa Origem
  const handleEmpresaChange = (selectedOption) => {
    setSelectedEmpresa(selectedOption);
    setSelectedPlanta(null); // Reseta a planta quando a empresa muda
    setSelectedIntercambio(null); // Reseta o intercambio
  };

  const handlePlantaChange = (selectedOption) => {
    setSelectedPlanta(selectedOption); // Atualiza o valor da planta selecionada
  };

  // Empresa Parceira
  const handleEmpresaParceiraChange = (selectedOption) => {
    setSelectedEmpresaParceira(selectedOption);
    setSelectedPlantaParceira(null); // Reseta a planta parceira quando a empresa parceira muda
    setSelectedIntercambio(null); // Reseta o intercambio
  };

  const handlePlantaParceiraChange = (selectedOption) => {
    setSelectedPlantaParceira(selectedOption); // Atualiza o valor da planta parceira selecionada
  };

  // Grupo Documento
  const handleGrupoDocumentoChange = (selectedOption) => {
    setSelectedGrupoDocumento(selectedOption);
    setSelectedDocumento(null); // Reseta o documento quando o grupo de documento muda
    setSelectedIntercambio(null); // Reseta o intercambio
  };

  const handleDocumentoChange = (selectedOption) => {
    setSelectedDocumento(selectedOption); // Atualiza o valor do documento selecionado
  };


  // Intercambio
  const handleIntercambioChange = (selectedOption) => {
    setSelectedIntercambio(selectedOption); // Armazena o valor selecionado
  };

  const handleCancel = () => {
    navigate(-1); // Redireciona para a página anterior
  };

  const handleVisivelClick = () => {
    const newState = !visivel;  // Alterna entre true e false
    console.log("Novo estado de Visível:", newState); // Verifica no console
    setVisivel(newState); // Atualiza o estado
  };

  const handleAtivoClick = () => {
    const newState = !ativo;  // Alterna entre true e false
    console.log("Novo estado de ativo:", newState); // Verifica no console
    setAtivo(newState); // Atualiza o estado
  };

  // Submeter as alterações
  const handleSubmit = async (e) => {
    e.preventDefault();

   // Convertendo os estados para 'S' ou 'N'
    const visivelToSend = visivel ? "S" : "N";
    const ativoToSend = ativo ? "S" : "N";

    const dataToSend = {
      ID_Permissao: parseInt(id, 10), // Forçar `id` como inteiro
      ID_Usuario_Controle: userControle.ID_Usuario,
      ID_Empresa: selectedEmpresa ? selectedEmpresa.value : null,
      ID_Planta: selectedPlanta ? selectedPlanta.value : null,
      ID_Empresa_Destino: selectedEmpresaParceira ? selectedEmpresaParceira.value : null,
      ID_Planta_Destino: selectedPlantaParceira ? selectedPlantaParceira.value : null,
      ID_Documento_Grupo: selectedGrupoDocumento ? selectedGrupoDocumento.value : null,
      ID_Documento: selectedDocumento ? selectedDocumento.value : null,
      ID_Intercambio: selectedIntercambio ? selectedIntercambio.value : null,
      Visivel: visivelToSend,  // Aqui estamos enviando "S" ou "N"
      Ativo: ativoToSend,      // Aqui também estamos enviando "S" ou "N"
    };

    //console.log('dataToSend', dataToSend);
    // Salvar alterações (implementação futura)
    await EditaPermissao(dataToSend, cookies._csrf_token.csrfToken);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Tables" breadcrumbItem="Editar Permissões" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                     <div className="email-usuario">
                       <Label for="Email">Email</Label>
                       
                          <Input
                            type="email"
                            name="Email"
                            id="Email"
                            value={selectedEmail}                            
                            disabled
                          />
                     </div>
                     <FormGroup><br/>
                      <Label for="Usuario">Usuário</Label>
                      <Input
                        type="text"
                        id="Usuario"
                        value={`${selectedUsuarioID} - ${selectedNome}`}
                        disabled
                      />
                    </FormGroup>
<hr/>
                    <Row>
                      {/* Coluna Esquerda */}
                      <Col md={6}>
                        {/* Empresa Origem */}
                        <FormGroup>
                          <Label for="Empresa">Empresa</Label>
                          <div className="empresa-combobox">
                            <ComboboxEmpresa 
                              ID_Usuario={userControle.ID_Usuario}
                              onChange={handleEmpresaChange} 
                              value={selectedEmpresa} // Preencher com valor inicial
                            />
                          </div>
                        </FormGroup>

                        {/* Planta Origem */}
                        {selectedEmpresa && (
                          <FormGroup>
                            <Label for="Planta">Planta</Label>
                            <div className="planta-combobox">
                              <ComboboxEmpresaPlanta 
                                ID_Empresa={selectedEmpresa.value} 
                                onChange={handlePlantaChange} 
                                value={selectedPlanta} // Preencher com valor inicial
                              />
                            </div>
                          </FormGroup>
                        )}

                        {/* Grupo Documento */}
                          <FormGroup>
                            <Label for="GrupoDocumento">Grupo Documento</Label>
                            <div className="grupo-documento-combobox">
                              <ComboboxGrupoDocumento 
                                onChange={handleGrupoDocumentoChange} 
                                value={selectedGrupoDocumento} // Preenche com o valor inicial
                              />
                            </div>
                          </FormGroup>

                          {selectedGrupoDocumento && (
                            <FormGroup>
                              <Label for="Documento">Documento</Label>
                              <div className="documento-combobox">
                                <ComboboxDocumento 
                                  ID_Documento_Grupo={selectedGrupoDocumento.value} 
                                  onChange={handleDocumentoChange} 
                                  value={selectedDocumento} // Preenche com o valor inicial
                                />
                              </div>
                            </FormGroup>
                            )}

                           <Label for="intercambio">Intercambio</Label>
                        {selectedEmpresa && selectedEmpresaParceira && selectedGrupoDocumento && (
                          <div className="intercambio-combobox">
                            <ComboboxIntercambio
                              ID_Empresa={selectedEmpresa.value}
                              ID_Empresa_Parceira={selectedEmpresaParceira.value}
                              ID_Documento_Grupo={selectedGrupoDocumento.value}
                              onChange={handleIntercambioChange}
                              value={selectedIntercambio}
                            />
                          </div>
                        )}

                      </Col>

                      {/* Coluna Direita */}
                      <Col md={6}>
                       

                        {/* Empresa Parceira */}
                        <FormGroup>
                          <Label for="EmpresaParceira">Empresa Parceira</Label>
                          <div className="empresa-parceira-combobox">
                            <ComboboxEmpresaParceira 
                              ID_Usuario={userControle.ID_Usuario}
                              onChange={handleEmpresaParceiraChange} 
                              value={selectedEmpresaParceira} // Preencher com valor inicial
                            />
                          </div>
                        </FormGroup>

                        {/* Planta Parceira */}
                        {selectedEmpresaParceira && (
                          <FormGroup>
                            <Label for="PlantaParceira">Planta Parceira</Label>
                            <div className="planta-parceira-combobox">
                              <ComboboxPlantaParceira 
                                ID_Empresa_Parceira={selectedEmpresaParceira.value} 
                                onChange={handlePlantaParceiraChange} 
                                value={selectedPlantaParceira} // Preencher com valor inicial
                              />
                            </div>
                          </FormGroup>
                        )}
                        {/* Switches Visível e Ativo */}
                        <FormGroup>
                          <Label for="Visivel">Visível</Label>
                          <div className="form-check form-switch">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="visivelSwitch"
                              checked={visivel}  // O estado de 'visivel' controla o checkbox
                              onClick={handleVisivelClick}  // Usamos o onClick para alternar o estado
                            />
                            <label className="form-check-label" htmlFor="visivelSwitch">
                              Visível
                            </label>
                          </div>
                        </FormGroup>

                        <FormGroup>
                          <Label for="Ativo">Ativo</Label>
                          <div className="form-check form-switch">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="ativoSwitch"
                              checked={ativo}  // O estado de 'ativo' controla o checkbox
                              onClick={handleAtivoClick}  // Usamos o onClick para alternar o estado
                            />
                            <label className="form-check-label" htmlFor="ativoSwitch">
                              Ativo
                            </label>
                          </div>
                        </FormGroup>

                      </Col>
                    </Row>
                    <hr/>
                    <Button color="primary" type="submit" className="ml-3 submit-button">Salvar Alterações</Button>
                    <Button color="secondary" type="button" className="ml-3 submit-button" onClick={handleCancel} style={{ marginLeft: '10px' }}>Cancelar</Button> {/* Botão Cancelar */}
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PermissaoEdit;
